import React from 'react';
import CommentItem from './CommentItem';
import ImageViewer from '../../../native/ImageViewer';
export default class CommentList extends React.Component{
  render(){
    let { commentList } = this.props;
    if(commentList.length === 0){
      return <div className="no-comments">暂无当前类别下评价</div>;
    }
    return (
      <ul className="comment-list">
        {
          commentList.map((item, index) =>{
            return <CommentItem
              key={item.comment_id}
              item={item}
              showBigImage={this.showBigImage} />;
          })
        }
      </ul>
    );
  }

  showBigImage = (index, pic_list)=>{
    let photos = pic_list.map((item)=>{
      return { 
        url: item.url,
        description:  ''
      };
    });

    ImageViewer({
      title: '',
      photos: photos,
      showIndex: index + 1,
      success: function (response) {
        console.log(response);
      }
    });
  }
}







// WEBPACK FOOTER //
// ./src/components/Poi2/Comment/CommentList.js